import { render, staticRenderFns } from "./refrigerant-factors.vue?vue&type=template&id=1c128091&scoped=true"
import script from "./refrigerant-factors.vue?vue&type=script&lang=js"
export * from "./refrigerant-factors.vue?vue&type=script&lang=js"
import style0 from "./refrigerant-factors.vue?vue&type=style&index=0&id=1c128091&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c128091",
  null
  
)

export default component.exports